module.exports = __webpack_public_path__ + "img/en-za.321feef6.svg";